import { StatePreV9, StateV9 } from './9_migrate_empty_weitere_vertraege.interface';

export const migrateEmptyWeiterenVertrag = (
  previousState: StatePreV9,
  newVersion: number,
): StateV9 => {
  if (
    previousState.weitereVertraege?.length === 1 &&
    previousState.weitereVertraege?.[0].vnWechsel === false &&
    !previousState.weitereVertraege?.[0].zielprodukt &&
    previousState.weitereVertraege?.[0].asNummer === ''
  ) {
    return {
      ...previousState,
      version: newVersion,
      weitereVertraege: [],
    };
  }
  return {
    ...previousState,
    version: newVersion,
    weitereVertraege: previousState.weitereVertraege,
  };
};
